import { canUseDOM } from '@ps/web-core-utils';

import { Fork } from '@swf/components/StarsWizard/Flow';

import SignupCAONRedirect from '../components/SignupCAONRedirect/SignupCAONRedirect';

import { Guard } from './useSignupGuards';

export const forkProvinceAppRedirect = new Fork(
  Guard.CheckIsEmbedded,
  [SignupCAONRedirect],
  [
    {
      name: 'exitProvince',
      entry: ({ values: { country, state }, data: { redirectUrl } }) => {
        const url = new URL(redirectUrl.url);
        Object.entries({ country, state }).forEach(([key, value]) =>
          url.searchParams.append(key, value)
        );

        if (canUseDOM) {
          window.location.href = url.toString();
        }
      },
      type: 'final'
    }
  ]
);
